import log from 'salvo-lite/log'
import axios from 'axios'
class ReturnClear {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._url = window.location.hash
        this._clear = elem.getAttribute('data-return-clear')
        this._cartIcon = elem.querySelector('.site-header__icon')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        if (this._url.includes(this._clear)) {
            axios.post('/cart/clear.js')
            this._cartIcon.classList.remove('has-items')
            this._cartIcon.setAttribute('data-cart-count', '0')
        }
    }
}

export default ReturnClear



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ReturnClear.js